import { CommonModule } from '@angular/common';
import { booleanAttribute, Component, effect, input, OnChanges, output, signal, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

import { NzButtonModule } from 'ng-zorro-antd/button';

import { BaseControlComponent } from '@base/base-control.component';
import { Guid, stopEvent } from '@models';
import { StoreService } from '@services/store.service';
import { SelectTagsDrawerComponent } from '@shared/_drawers/select-tags/select-tags-drawer.component';
import { TagComponent } from '@shared/_views/tag';

@Component({
    selector: 'vz-tags-select',
    template: `
        <div class="layout flex center">
            <div class="layout flex wrap gap025 bg bc c-t vz-open-click" style="padding: 3px 4px; min-height: 32px;"
                [class.b1s]="vzVariant() == 'outlined'"
                (click)="showTagsEdit.set(true)">
                @for (tagId of tagIds(); track tagId) {
                    @if (allowRemoveByOne()) {
                        <div class="layout center bg-dd br6" style="padding: 0 1px;">
                            <vz-tag [tagId]="tagId" />
                            <i class="vzi-cross vz-btn-c-err ph025" (click)="removeTag(tagId, $event)"></i>
                        </div>
                    }
                    @else {
                        <vz-tag [tagId]="tagId" />
                    }
                }
                @empty {
                    <span class="txt-ll" style="margin-left: 6px;">{{ placeholder() }}</span>
                }
                @if (tagIds().length) {
                    <a class="ml05">изменить</a>
                }
            </div>
            @if (tagIds().length) {
                <button nz-button nzType="text" class="ant-btn-icon-only" (click)="control.setValue([])"><i class="vzi-cross txt-err"></i></button>
            }
        </div>
        @if (showTagsEdit()) {
            <vz-select-tags-drawer
                mode="multiselect"
                showOrgTags="true"
                [noEditToggle]="!allowNew()"
                [noCreateButton]="!allowNew()"
                [projectId]="projectId()"
                [selected]="tagIds()"
                [showAllProjects]="showAllProjects()"
                (closePanel)="updateTags($event);" />
        }
    `,
    styles: [':host { display: flex; flex: 1; flex-basis: 0px; }'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: TagsSelectComponent
        }
    ],
    imports: [
        CommonModule, ReactiveFormsModule,
        NzButtonModule,
        TagComponent, SelectTagsDrawerComponent
    ]
})
export class TagsSelectComponent extends BaseControlComponent {
    readonly placeholder         = input<string>('Выберите теги');
    readonly projectId           = input<Guid>();
    readonly allowNew            = input<boolean, unknown>(false, { transform: booleanAttribute });
    readonly showClearButton     = input<boolean, unknown>(true, { transform: booleanAttribute });
    readonly allowRemoveByOne    = input<boolean, unknown>(true, { transform: booleanAttribute });
    readonly showAllProjects     = input(false, { transform: booleanAttribute });

    readonly drawerOpened        = output<boolean>();

    readonly tagIds              = signal<string[]>([]);
    readonly showTagsEdit        = signal<boolean>(false);

    constructor(protected _store: StoreService) {
        super(_store);
        this._S.value = this.control.valueChanges.subscribe(v => this.tagIds.set(v || []));
        effect(() => this.drawerOpened.emit(this.showTagsEdit()));
    }

    updateTags(ids?: Guid[]): void {
        if (ids) {
            this.control.setValue(ids);
        }
        this.showTagsEdit.set(false);
    }

    removeTag(tid: Guid, e?: MouseEvent): void {
        stopEvent(e);
        this.control.setValue(this.control.value.filter((id: Guid) => id != tid));
    }

}
